module.exports = __webpack_public_path__ + "static/img/main4_3.5b7ae8c5.png";